const el = {
  home: {
    biometric_label: "ΒΙΟΜΕΤΡΙΚΗ ΕΠΑΛΗΘΕΥΣΗ ΤΑΥΤΟΤΗΤΑΣ",
    title: "Αντίστροφη αναζήτηση προσώπων με ευκολία",
    description:
      "Ανεβάστε ένα πορτρέτο υψηλής ανάλυσης για διασταύρωση με παγκόσμια ψηφιακά αρχεία χρησιμοποιώντας προηγμένη νευρωνική αντιστοίχιση.",
    drag_drop: "Σύρτε και αποθέστε την εικόνα σας",
    file_formats: "Υποστηρίζει RAW, JPEG ή PNG (Μέγ. 15MB)",
    select_file: "ΕΠΙΛΟΓΗ ΑΡΧΕΙΟΥ ΑΠΟ ΤΟ ΣΥΣΤΗΜΑ",
    initiate_scan: "Έναρξη Εγκληματολογικής Σάρωσης",
    upload_hint: "ΠΑΡΑΚΑΛΩ ΑΝΕΒΑΣΤΕ ΜΙΑ ΕΙΚΟΝΑ ΓΙΑ ΝΑ ΣΥΝΕΧΙΣΕΤΕ",
    uploading: "Μεταφόρτωση",
    searching: "Σάρωση",
    result_title: "Αποτελέσματα",
    drop_here: "Αποθέστε την εικόνα εδώ...",
    billion_faces:
      "Συγκρίνετε με πάνω από 1 δισεκατομμύριο πρόσωπα στο internet",
    login_to_search: "Σύνδεση για αναζήτηση",
    login_required:
      "Συνδεθείτε ή δημιουργήστε λογαριασμό για να χρησιμοποιήσετε αυτήν την εφαρμογή",
    not_enough_tokens: "Ανεπαρκή tokens",
    please_wait: "Παρακαλώ περιμένετε μερικά λεπτά",
    leave_confirmation:
      "Υπάρχει μια διαδικασία σε εξέλιξη. Είστε σίγουρος ότι θέλετε να φύγετε;",
  },
  sources: {
    section_title: "Πηγές που Αναζητούμε",
    social_media: {
      name: "Κοινωνικά Δίκτυα",
      description: "Διασταύρωση σε μεγάλα κοινωνικά δίκτυα και δημόσια προφίλ.",
    },
    web: {
      name: "Web",
      description:
        "Σαρώνει το ανοιχτό web για δημόσια διαθέσιμα δεδομένα προσώπου.",
    },
    scammers: {
      name: "Απατεώνες",
      description:
        "Αντιστοίχιση με γνωστές βάσεις δεδομένων ταυτότητας απατεώνων.",
    },
    sexual_offenders: {
      name: "Σεξουαλικοί Παραβάτες",
      description: "Διασταύρωση με δημόσια μητρώα εγγεγραμμένων παραβατών.",
    },
    videos: {
      name: "Βίντεο",
      description:
        "Εξάγει και αντιστοιχεί πρόσωπα από δημόσιες πλατφόρμες βίντεο.",
    },
    police_photos: {
      name: "Αστυνομικές Φωτογραφίες",
      description:
        "Σύγκριση με δημόσια διαθέσιμες αστυνομικές βάσεις δεδομένων.",
    },
    news_and_blogs: {
      name: "Ειδήσεις & Blogs",
      description:
        "Αναζήτηση σε αρχεία ειδήσεων, συντακτικό περιεχόμενο και blogs.",
    },
  },
  header: {
    scan: "ΣΑΡΩΣΗ",
    history: "ΙΣΤΟΡΙΚΟ",
    pricing: "ΤΙΜΕΣ",
    account: "ΛΟΓΑΡΙΑΣΜΟΣ",
    logout: "ΑΠΟΣΥΝΔΕΣΗ",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Όλα τα δικαιώματα διατηρούνται. Επαλήθευση Ταυτότητας Ακριβείας.",
    privacy: "Πολιτική Απορρήτου",
    terms: "Όροι Υπηρεσίας",
    docs: "Τεκμηρίωση",
    support: "Υποστήριξη",
  },
  common: {
    loading: "Φόρτωση...",
    error: "Σφάλμα",
    cancel: "Ακύρωση",
    back: "Πίσω",
  },
  errors: {
    upload_failed: "Αποτυχία μεταφόρτωσης. Δοκιμάστε ξανά.",
    not_enough_tokens:
      "Δεν έχετε αρκετά tokens για να πραγματοποιήσετε αυτήν την αναζήτηση.",
  },
  login: {
    disclaimer:
      "Χρειάζεστε λογαριασμό για να χρησιμοποιήσετε αυτήν την εφαρμογή. Δεν στέλνουμε spam και δεν μοιραζόμαστε το email σας. Σας προτείνουμε να συνδεθείτε με Apple για να προστατέψετε την ιδιωτικότητά σας.",
  },
  results: {
    input_source: "ΠΗΓΗ ΕΙΣΟΔΟΥ",
    match_thumbnail: "Μικρογραφία αντιστοίχισης",
    extraction_id: "ΑΝΑΓΝΩΡΙΣΤΙΚΟ ΕΞΑΓΩΓΗΣ",
    scan_analysis: "Ανάλυση σάρωσης",
    scan_description:
      "Ολοκληρώθηκε η βιομετρική αντίστροφη αναζήτηση. Βρέθηκαν %{count} πιθανές αντιστοιχίες σε δημόσια μητρώα και κοινωνικούς δείκτες.",
    col_identity_map: "ΧΑΡΤΗΣ ΤΑΥΤΟΤΗΤΑΣ",
    col_verification_path: "ΔΙΑΔΡΟΜΗ ΕΠΑΛΗΘΕΥΣΗΣ",
    col_bio_match_score: "ΒΑΘΜΟΛΟΓΙΑ ΒΙΟ",
    col_action: "ΕΝΕΡΓΕΙΑ",
    export_pdf: "Εξαγωγή PDF",
    exporting: "Δημιουργία...",
    verified: "ΕΠΑΛΗΘΕΥΜΕΝΟ",
    details: "ΛΕΠΤΟΜΕΡΕΙΕΣ",
    details_tooltip: "Εκτέλεση ακριβούς σύγκρισης προσώπου",
    details_loading: "Σύγκριση...",
    copied: "Αντιγράφηκε!",
    copy_url: "Αντιγραφή URL",
    displaying: "Εμφάνιση %{count} από %{total} ανιχνεύσεις",
  },
};

export default el;
